import { render } from "./NormvaluesExport.vue?vue&type=template&id=2af0b57e&scoped=true"
import script from "./NormvaluesExport.vue?vue&type=script&lang=js"
export * from "./NormvaluesExport.vue?vue&type=script&lang=js"

import "./NormvaluesExport.vue?vue&type=style&index=0&id=2af0b57e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af0b57e"]])

export default __exports__